import { OPEN_MODAL_CONTACT } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (value) => creditFileActions[OPEN_MODAL_CONTACT](value);
